// Simplified API wrapper using fetch()
// Uses environment variable `REACT_APP_API_URL` or defaults to http://localhost:4000
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000';

// Fetch all users
export async function fetchUsers() {
  try {
    const res = await fetch(`${API_BASE}/users`);
    if (!res.ok) throw new Error('Network response not ok');
    return await res.json();
  } catch (err) {
    console.error('Error fetching users', err);
    return [];
  }
}

// Create a new user
export async function createUser(user) {
  try {
    const res = await fetch(`${API_BASE}/users`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(user),
    });
    if (!res.ok) throw new Error('Failed to create user');
    return await res.json();
  } catch (err) {
    console.error('Error creating user', err);
    return null;
  }
}
